/**
 * File: src/components/game-wiki.js
 * Mô tả: Component giao diện đọc và tra cứu tài liệu/hướng dẫn game trực tiếp hỗ trợ đa ngôn ngữ Anh / Việt.
 * Liên quan: src/data/ant-clash-wiki.js, src/i18n/i18n-service.js
 */

import { createElement } from '../utils/dom.js';
import { antClashWikiDataEn, antClashWikiDataVi } from '../data/ant-clash-wiki.js';
import { getLanguage, t, onLanguageChange } from '../i18n/i18n-service.js';

export const renderGameWiki = () => {
  const section = createElement('section', {
    className: 'section',
    attributes: { id: 'wiki', style: 'background: var(--bg-primary);' },
  });

  const container = createElement('div', { className: 'container' });
  let activeTabId = 'intro';

  const renderContent = () => {
    const lang = getLanguage();
    const wikiData = lang === 'en' ? antClashWikiDataEn : antClashWikiDataVi;

    container.innerHTML = `
      <h2 class="section-title">${lang === 'en' ? 'Game Manual & Documentation Center' : 'Trung Tâm Tài Liệu & Hướng Dẫn Game'}</h2>
      <p class="section-subtitle">${
        lang === 'en'
          ? 'Browse lore, 12 ant classes, upgrade tables, and tactical strategies for Ant Clash.'
          : 'Tra cứu trực tiếp toàn bộ bối cảnh, 12 chủng loại kiến, bảng nâng cấp và chiến thuật thi đấu Ant Clash.'
      }</p>

      <div style="background: var(--bg-secondary); border-radius: var(--radius-lg); border: var(--border-glass); overflow: hidden; margin-top: 2rem;">
        <div id="wiki-tab-bar" style="display: flex; overflow-x: auto; background: var(--bg-tertiary); border-bottom: var(--border-glass);"></div>
        <div id="wiki-content-body" style="padding: 2.5rem 2rem; min-height: 350px;"></div>
      </div>
    `;

    const tabBar = container.querySelector('#wiki-tab-bar');
    const contentBody = container.querySelector('#wiki-content-body');

    wikiData.forEach((tab) => {
      const isActive = tab.id === activeTabId;
      const btn = createElement('button', {
        className: `wiki-tab-btn ${isActive ? 'active' : ''}`,
        attributes: {
          style: `padding: 1rem 1.5rem; font-weight: 600; font-size: 0.95rem; border: none; background: ${
            isActive ? 'var(--bg-secondary)' : 'transparent'
          }; color: ${isActive ? 'var(--color-accent)' : 'var(--color-text-muted)'}; border-bottom: 3px solid ${
            isActive ? 'var(--color-accent)' : 'transparent'
          }; transition: all var(--transition-fast); white-space: nowrap; cursor: pointer;`,
        },
        text: tab.title,
      });

      btn.addEventListener('click', () => {
        activeTabId = tab.id;
        renderContent();
      });

      tabBar.appendChild(btn);
    });

    const currentTab = wikiData.find((t) => t.id === activeTabId) || wikiData[0];
    contentBody.innerHTML = currentTab.content;
  };

  renderContent();
  onLanguageChange(() => renderContent());

  section.appendChild(container);
  return section;
};
